module.exports = {
  methods: {
    // handlerPag
    toDetails(item) {
      const { id, link, moduleId } = item;
      let arr = [
        {
          code: "analysisReport",
          name: "informationServiceAnalysisDetail",
          query: {},
        }, // 分析报告
        {
          code: "competitionDynamics",
          name: "informationServiceCompeteActivity",
          query: {},
        }, // 竞赛动态
        {
          code: "trainingLectures",
          name: "informationServiceLectureActivity",
          query: {},
        }, // 培训讲座
        {
          code: "relatedConsultation",
          name: "informationServiceConsultDetail",
          query: {},
        }, // 相关咨询
        {
          code: "policiesRegulations",
          name: "resourceNavigationPolicyDetail",
          query: {},
        }, // 政策法规
        {
          code: "newsExpress",
          name: "resourceNavigationNewsDetail",
          query: {},
        }, // 新闻速递
        { code: "xwshsxx", name: "" }, // 华师信息素养培训资料
        { code: "huaKnowledgeData", name: "" }, //华师知识产权数据库
        { code: "abroadData", name: "" }, // 国内外官方网站及数据库
      ];

      arr.forEach((res) => {
        if (res.code === item.sysMenu.code) {
          if (res.name !== "") {
            res.query.id = id;
            res.query.name = item.sysMenu.menuName;
            res.query.selectedId = moduleId;
            res.query.code = item.sysMenu.code;
            console.log(res.query);
            this.$router.push({ query: res.query, name: res.name });
          } else {
            window.open(link);
          }
        }
      });
    },
  },
};
